// Sidebar.js
import React, { useState } from 'react';
import NavBar from './NavBar';
import SearchBar from './SearchBar';
import { Outlet } from 'react-router-dom';
import "../styles/sidebar.scss";
import CopyrightFooter from '../components/CopyrightFooter';

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(true);
  const toggleSidebar = () => setIsOpen(prev => !prev);

  return (
    <>
      <SearchBar isInput={false} isSidebarOpen={isOpen} toggleSidebar={toggleSidebar} />
      <div className='flex relative'>
        <NavBar isSidebarOpen={isOpen} toggleSidebar={toggleSidebar} />
        <div className='flex-1 pl-[27px] pr-[17px] pb-0'>
          <main className='flex-1 bg-white main-content relative z-0 transition-all duration-300 ease-in-out dark:bg-black'>
            <Outlet />
            <CopyrightFooter />
          </main>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
